import { Script } from "gatsby"
export const swiftypeId = process.env.GATSBY_SWIFTYPE_ID || "x19oDzidpFguHpeE5zrw"

export const swiftypeProps = (searchbarText) => ({
  __html: `
    <script type="application/json">
      {
        "installkey": "${swiftypeId}",
        "noresultstext": "${searchbarText || "Sorry, no results found."}"
      }
    </script>
  `,
})

const Swiftype = () => <Script defer type="text/javascript" src="/g-static/fastly-swiftype/bundle.js" />

export default Swiftype
